exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-our-team-tsx": () => import("./../../../src/pages/our-team.tsx" /* webpackChunkName: "component---src-pages-our-team-tsx" */),
  "component---src-pages-static-calc-tsx": () => import("./../../../src/pages/static-calc.tsx" /* webpackChunkName: "component---src-pages-static-calc-tsx" */),
  "component---src-pages-web-app-tsx": () => import("./../../../src/pages/web-app.tsx" /* webpackChunkName: "component---src-pages-web-app-tsx" */)
}

